import { __decorate, __metadata } from "tslib";
import { Type } from "class-transformer";
import { v4 as uuidv4 } from "uuid";
import { ActionItemModel } from "./actionItem";
import { ClientUpdateAttachmentModel } from "./clientUpdateAttachment";
let UpdatesTimelineEntryModel = /** @class */ (() => {
    class UpdatesTimelineEntryModel {
        constructor() {
            this.id = uuidv4();
            this.entryDate = null;
            this.updateSideId = "";
            this.updateSideLabel = "";
            this.interactionTypeId = null;
            this.interactionTypeLabel = null;
            this.teamId = null;
            this.teamName = null;
            this.updateHtml = "";
            this.isUpdatesOnly = false;
            this.createdByName = "";
            this.createdByImageURL = "";
            this.hasActionItems = false;
            this.hasLinks = false;
            this.hasAttachments = false;
            this.actionItems = [];
            this.attachments = [];
        }
    }
    __decorate([
        Type(() => ActionItemModel),
        __metadata("design:type", Array)
    ], UpdatesTimelineEntryModel.prototype, "actionItems", void 0);
    __decorate([
        Type(() => ClientUpdateAttachmentModel),
        __metadata("design:type", Array)
    ], UpdatesTimelineEntryModel.prototype, "attachments", void 0);
    return UpdatesTimelineEntryModel;
})();
export { UpdatesTimelineEntryModel };
export default class UpdatesTimelineEntry extends UpdatesTimelineEntryModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
}
